import React from 'react'
import PropTypes from 'prop-types'

import {Grid} from '@material-ui/core'

import {
  Widget,
  WidgetActions,
  WidgetBody,
  WidgetHeader,
  DropdownInput,
  InstrumentsFilterList
} from '../index'
import PrimaryButton from '../../../../components/Buttons/PrimaryButton';
import Switch from '../../../../components/AssetModal/components/Switch';
import { FilterIcon, SearchIcon } from '../../../../images';
import ErrorsContainer from "../ErrorsContainer/ErrorsContainer";

import useStyles, {switchStyles} from './styles'


const FavListSwitch = ({classes, isCustomerApp, onlyFavorite, setOnlyFavorite, disabled}) => {
  const switchClasses = switchStyles();

  if(!!isCustomerApp) return null; /* Customer does not have favorite list -> do not display switch */

  return (
    <Grid item>
      <div className={classes.favouriteInstrumentsContainer}>
        <Switch
          value={onlyFavorite}
          handleValueChanged={setOnlyFavorite}
          disabled={disabled}
          showLabel={false}
          customClasses={switchClasses}
        />
        <span className={classes.favouriteInstrumentsText}>Suche nur von Favoritenlisten</span>
      </div>
    </Grid>
  )
};

function InstrumentsFilter(props) {

  const {
    instruments,
    loading,
    onFiltersExtendedButtonClick,
    onSearchActivate,
    onAddAssetClick,
    instrumentsDisabled,
    errors,
    extraActions,
    title,
    disableDropdown,
    disabled,
    isCustomerApp,
    WidgetProps,
    useDisabledOnExtraActions,
    customClasses
  } = props;

  const classes = useStyles();

  const [searchValue, setSearchValue] = React.useState();
  const [onlyFavorite, setOnlyFavorite] = React.useState(false)

  const handleSearchActivate = (value) => {
    if (onSearchActivate) {
      onSearchActivate(value, onlyFavorite)
    }
  }

  const handleSearchValueChange = (value) => {
    setSearchValue((value && value.replace(/ /g, "").length) ? value : '')
  }

  const handleValueApprove = (value) => {
    handleSearchActivate(typeof value === 'string' ? value.trim() : searchValue)
  };

  const SwitchEl = (
    <FavListSwitch
      classes={classes}
      disabled={disabled}
      isCustomerApp={isCustomerApp}
      onlyFavorite={onlyFavorite}
      setOnlyFavorite={setOnlyFavorite}
    />
  );

  return (
    <Widget {...WidgetProps}>
      <WidgetHeader>
        <Grid container justify="space-between" alignItems="center">
          <Grid item>
            <h2 className={customClasses.productSearchLabel}>{title}</h2>
          </Grid>
          {!!extraActions && SwitchEl}
        </Grid>
      </WidgetHeader>
      <WidgetBody style={{padding: "4px 0 8px"}}>
        <Grid container spacing={1}>
          <Grid item xs>
            <DropdownInput
              value={searchValue}
              placeholder="Produktname, ISIN, oder WKN suchen"
              dropdownContent={(
                <>
                  {errors ? (
                    <ErrorsContainer errors={errors} />
                  ) : (
                    <InstrumentsFilterList
                      instruments={instruments}
                      pattern={searchValue}
                      loading={loading && !disableDropdown}
                      onAddAssetClick={onAddAssetClick}
                      instrumentsDisabled={instrumentsDisabled}
                      disabled={disabled}
                    />
                  )}
                </>
              )}
              dropdownVisible={(instruments || loading) && !disableDropdown}
              isOptionsLoading={!!loading}
              onChange={handleSearchValueChange}
              onValueApprove={handleValueApprove}
              autoApprove={false}
              isSearchDisabled={loading || disabled}
              disabled={disabled}
              isAssetSearch
            />
          </Grid>
          <Grid item xs={'auto'}>
            <PrimaryButton
              icon={<SearchIcon color={'currentColor'} />}
              text="Suche starten"
              onButtonClick={handleValueApprove}
              disabled={loading || disabled}
              style={{height: '100%'}}
            />
          </Grid>
        </Grid>
      </WidgetBody>
      <WidgetActions>
        <Grid container spacing={!!extraActions ? 1 : 3} alignItems={'center'}>
          {extraActions
            ? extraActions.map(btn => (
              <Grid item key={btn.text} className={classes.extraActionItem}>
                <PrimaryButton
                  text={btn.text}
                  icon={btn.icon}
                  variant={btn.variant}
                  disabled={btn.disabled || (useDisabledOnExtraActions && disabled)}
                  onButtonClick={btn.onButtonClick}
                  tooltip={btn.tooltip}
                />
              </Grid>
            ))
            : SwitchEl
          }
          {!isCustomerApp &&
            <Grid item style={!!extraActions ? { marginLeft: 'auto'} : {}} className={classes.extraActionItemContained}>
              <PrimaryButton
                variant={'text'}
                text="Erweiterte Suche/ Expertenfilter"
                icon={<FilterIcon color={'currentColor'} />}
                onButtonClick={onFiltersExtendedButtonClick}
                disabled={disabled}
              />
            </Grid>
          }
        </Grid>
      </WidgetActions>
    </Widget>
  )
}

InstrumentsFilter.propTypes = {
  /** List of instruments */
  instruments: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  })).isRequired,

  /** Flag, that indicate, if instruments data is loading at the moment, or not */
  loading: PropTypes.bool,

  /** Flag, for showing or not dropdown even if loading state */
  disableDropdown: PropTypes.bool,

  /** Handler for 'Expert Filters' button click event */
  onFiltersExtendedButtonClick: PropTypes.func.isRequired,

  /** Handler for search input approved */
  onSearchActivate: PropTypes.func.isRequired,
  
  /** Hanler for onAddAsset event */
  onAddAssetClick: PropTypes.func,

  /** Instruments, that could not be selected */
  instrumentsDisabled: PropTypes.arrayOf(PropTypes.shape({})),

  /** Extra Buttons, that could not be clicked */
  extraActions: PropTypes.arrayOf(PropTypes.shape({})),

  /** Title for the panel */
  title: PropTypes.string
}

InstrumentsFilter.defaultProps = {
  instruments: [],
  loading: false,
  disableDropdown: false,
  title: "Investment hinzufügen",
  WidgetProps: {},
  customClasses: {},
  useDisabledOnExtraActions: false
}

export default InstrumentsFilter

